export default (href, options) => {
    Backbone.history.navigate(href, { trigger: true, ...options });
};
